<template>
    <div :class="`dash-list-panel${type ? (' dash-list-panel-'+type) : ''}`">
        <router-link :to="link + item.id" class="dash-list-item" v-for="item in list" :key="item.id">
            <span class="dash-list-item-title">{{ item.title }}</span>
            <span class="dash-list-item-date" v-if="type != 'img'">{{ item.createdate ? moment(item.createdate).format('YYYY-MM-DD') : (item.date || '') }}</span>
            <img class="dash-list-item-img" v-else-if="item.img" :src="item.img" /> 
        </router-link>
    </div>
</template>
<script>
import moment from "moment";
export default {
    props: ['list', 'link', 'type'],
    data() {
        return {
        }
    },
    created(){
    },
    mounted(){
    },
    methods: {
        moment
    }
}

</script>
<style lang="less" scoped>
    .dash-list-panel{
        border: 1px dashed #666;
        padding: 0 32px;
        box-sizing: border-box;
        width: 100%;
        .dash-list-item{
            height: 102px;
            line-height: 24px;
            border-bottom: 1px dashed #d5d5d5;
            width: 100%;
            display: flex;
            text-decoration: none;
            color: #222;
            justify-content: space-between;
            box-sizing: border-box;
            align-items: center;
            &-title{
                overflow: hidden;
                word-break: keep-all;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 18px;
            }
            &-date{
                color: #d5d5d5;
            }
            &-img{    
                width: 91px;
                height: 70px;
                border-radius: 8px;
                margin-left: 8px;
            }
        }
        .dash-list-item:last-child{
            border: none;
        }
    }

    .dash-list-panel-img{
        .dash-list-item{
            &-title{
                word-break: break-all;
                white-space: normal;
                flex: 1;
            }
        }
    }
@media screen and (max-width:960px){
    .dash-list-panel{
        border: none;
        padding: 0;
        .dash-list-item {
            border-bottom: 1px solid #F1F1F1!important;
            height: .68rem;
            padding: .16rem 0 .12rem;
            flex-wrap: wrap;
            &-title{
                font-size: .14rem;
                line-height: .2rem;
                margin-bottom: .08rem;
                width: 100%;
            }
            &-date{
                line-height: .12rem;
                font-size: .12rem;
            }
            &-img{
                width: .52rem;
                height: .40rem;
            }
        }
    }

    .dash-list-panel-img{
        .dash-list-item-title{
            width: unset;
            margin-bottom: 0;
            overflow : hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }
}
</style>